import React, { Component } from 'react';
import { withRouter } from '../WithRouterHOC';
import { connect } from 'react-redux';
import { Modal } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { _show_browser_warn, _get_client_down_url } from '../../store/Action';
import './index.scss';

class index extends Component {
  downPc = async () => {
    const url = await _get_client_down_url();
    window.open(url);
  };
  render() {
    const { browser_warn_vibale } = this.props.base;
    return (
      <Modal
        open={browser_warn_vibale}
        wrapClassName="transparent-body"
        centered={true}
        closable={false}
        footer={null}
        keyboard={false}
        maskClosable={false}
        width="620px"
        zIndex={2000}
        onCancel={_show_browser_warn.bind(this, false)}
      >
        <div className="browser-warn-content">
          <span
            className="close"
            onClick={_show_browser_warn.bind(this, false)}
          >
            <CloseOutlined style={{ fontSize: '16px' }} />
          </span>
          <h3 className="title">温馨提示</h3>
          <p>您当前浏览器版本过低，存在安全风险，建议您试一下我们的PC客户端</p>
          <div className="blink pc">
            <span className="sky" onClick={this.downPc}></span>
          </div>
          <p>也可以下载谷歌浏览器~</p>
          <div className="blink chrome">
            <a
              className="sky"
              href="https://www.google.cn/chrome"
              target="_blank"
              rel="noopener noreferrer"
            >
              下载chrome
            </a>
          </div>
        </div>
      </Modal>
    );
  }
}

export default connect((store) => ({ base: store }))(
  withRouter(index, { withRef: true })
);
